<template>
  <v-btn block :class="[`${situacaoClass}`, 'white--text', 'ma-0', 'caption']">
    <slot>Vistoria {{ situacao }}</slot>
  </v-btn>
</template>

<script>
  export default {
    props: ['situacao'],
    computed: {
      situacaoClass () {
        switch (this.situacao) {
          case 'realizada':
            return 'primary'
          case 'atrasada':
            return 'vermelho'
          case 'próxima':
            return 'amarelo'
          case 'em dia':
            return 'verde'
        }
      }
    }
  }
</script>

<style scoped>
  .upperCase { text-transform: uppercase; }
</style>



// WEBPACK FOOTER //
// ListaVistoriaSituacao.vue?7bbe673b